<template>
	<b-button
		:variant="variant"
		:to="to"
		class="border-0"
		:disabled="disabled"
		@click="onClick"
		v-b-tooltip.hover="{
			title: `${textTooltip}`,
			customClass: 'custom-tooltip',
			interactive: false,
			placement: 'bottom'
		}"
	>
		<b-icon icon="trash" variant="outline-danger" />
	</b-button>
</template>

<script>
export default {
	props: {
		variant: {
			type: String,
			default: "outline-danger"
		},
		to: {
			type: [String, Object],
			default: ""
		},
		disabled: {
			type: Boolean,
			default: false
		},
		textTooltip: {
			type: String,
			default: ""
		}
	},
	methods: {
		onClick() {
			this.$emit("click");
		}
	}
};
</script>
